// src/Component/SideData/Overview/AiAgentWorkFlow/IntentIndex.js
import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import SKILLS_BY_INDUSTRY from "./SkillIndustryList";
const backend_api_base_url = `${process.env.REACT_APP_SL_BE_BASE_ENV_PART}/${process.env.REACT_APP_STAGE_ENV}`;
import InferredFieldsBuilder from "./InferredFieldsBuilder";
import styles from "./IntentIndex.module.css";
import {
  FaAngleDown,
  FaInfoCircle,
  FaPlus,
  FaCheckCircle,
  FaTimesCircle,
  FaSearch,
  FaSyncAlt,
  FaChevronDown,
  FaChevronRight,
} from "react-icons/fa";
import ReusablePopup from "../../../../ReusablePopup";
import { RiDeleteBin6Line } from "react-icons/ri";
import NewCustomSkillModal from "./NewCustomSkillModal";

import {
  ComponentPickerModal,
  PinConfirmModal,
  resolveFieldComponent,
  fetchUiFieldComponentsLibrary,
} from "./utils/uiFieldComponentsShared";

console.log("intent index was being called???");

const fieldsDiag = { enabled: true, dump: true };

const logFieldsTrap = (reason, payload) => {
  if (!fieldsDiag.enabled) return;
  const block = { ts: new Date().toISOString(), reason, ...payload };
  console.warn(
    "🚨 [FIELDS_TRAP] " + reason + "\n" + JSON.stringify(block, null, 2),
  );
  try {
    window.__FIELDS_TRAPS__ = window.__FIELDS_TRAPS__ || [];
    window.__FIELDS_TRAPS__.push(block);
    if (window.__FIELDS_TRAPS__.length > 50) {
      window.__FIELDS_TRAPS__.shift();
    }
  } catch (_) {}
};

const FontAwesomeIconPicker = ({ onSelect, onClose }) => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!query.trim()) {
      setResults([]);
      return;
    }

    const timer = setTimeout(async () => {
      setLoading(true);
      try {
        const response = await fetch("https://api.fontawesome.com", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            query: `
              query SearchIcons($query: String!) {
                searchPaginated(version: "6.x", query: $query, pageSize: 30) {
                  icons {
                    id
                    label
                  }
                }
              }
            `,
            variables: { query: query },
          }),
        });
        const data = await response.json();
        setResults(data.data?.searchPaginated?.icons || []);
      } catch (err) {
        console.error("Icon search failed", err);
      } finally {
        setLoading(false);
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [query]);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10000,
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "20px",
          borderRadius: "8px",
          width: "600px",
          maxWidth: "90%",
        }}
      >
        <h3 style={{ marginTop: 0, marginBottom: "16px" }}>
          Select an Icon
        </h3>
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Type to search (e.g., 'coffee', 'user')..."
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "4px",
            border: "1px solid #ddd",
            marginBottom: "16px",
          }}
          autoFocus
        />
        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
          {loading && <p>Searching...</p>}
          {!loading && results.length === 0 && query && <p>No icons found.</p>}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(80px, 1fr))",
              gap: "10px",
            }}
          >
            {results.map((icon) => (
              <button
                key={icon.id}
                onClick={() => {
                  onSelect(`fa-solid fa-${icon.id}`);
                  onClose();
                }}
                style={{
                  padding: "10px",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  background: "#fff",
                }}
              >
                <i
                  className={`fa-solid fa-${icon.id}`}
                  style={{
                    fontSize: "24px",
                    marginBottom: "8px",
                    color: "#333",
                  }}
                ></i>
                <span
                  style={{
                    fontSize: "11px",
                    textAlign: "center",
                    wordBreak: "break-word",
                  }}
                >
                  {icon.label}
                </span>
              </button>
            ))}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "16px",
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "8px 16px",
              borderRadius: "4px",
              border: "none",
              backgroundColor: "#eee",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

const getIntentsForIndustry = (industry, subIndustry) => {
  const industryData = SKILLS_BY_INDUSTRY[industry];
  if (!industryData) return [];

  const defaultIntents = industryData.default || [];
  let extraIntents = [];
  if (subIndustry && industryData[subIndustry] && industryData[subIndustry].extras) {
    extraIntents = industryData[subIndustry].extras;
  }

  const allIntentNames = [...new Set([...defaultIntents, ...extraIntents])];
  const toDisplayName = (name) =>
    name
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

  return allIntentNames.map((name) => ({
    name: name,
    display_name: toDisplayName(name),
  }));
};

const detectSiblingFormatMismatch = (fields) => {
  if (!Array.isArray(fields) || fields.length < 2) return null;

  const FORMATTABLE_TYPES = new Set([
    "date",
    "time",
    "datetime",
    "datetime-local",
    "number",
    "integer",
    "float",
    "boolean",
  ]);

  const byType = {};
  fields.forEach((f) => {
    if (!f || !f.type) return;
    if (!FORMATTABLE_TYPES.has(f.type)) return;
    const key = f.type === "datetime-local" ? "datetime" : f.type;
    if (!byType[key]) byType[key] = [];
    byType[key].push(f);
  });

  for (const [type, group] of Object.entries(byType)) {
    if (group.length < 2) continue;
    const formats = new Set(group.map((f) => f.format || "(none)"));
    if (formats.size > 1) {
      const list = Array.from(formats).join(" vs ");
      return `These fields share the same type ("${type}") but use different formats (${list}). This is often a mistake — for example, a check-in and check-out date that ended up in different formats. Verify both before saving; your API will reject whichever one doesn't match.`;
    }
  }
  return null;
};

const PLACEHOLDER_RE = /\{\{\s*[^}]+?\s*\}\}/;
const isPlaceholder = (v) => typeof v === "string" && PLACEHOLDER_RE.test(v);

const inferFieldType = (value) => {
  if (typeof value === "string" && PLACEHOLDER_RE.test(value)) {
    return { type: "text", source: "placeholder-text" };
  }
  if (typeof value !== "string") {
    if (typeof value === "boolean") return { type: "boolean", source: "bool-literal" };
    if (typeof value === "number") return { type: "number", source: "number-literal" };
    if (value === null || value === undefined) return { type: "text", source: "null" };
    return { type: "text", source: "unknown" };
  }
  const trimmed = value.trim();
  if (trimmed === "") return { type: "text", source: "empty" };
  if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) return { type: "date", source: "regex-date" };
  if (/^\d{2}:\d{2}(:\d{2})?$/.test(trimmed)) return { type: "time", source: "regex-time" };
  if (/^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}(:\d{2})?/.test(trimmed)) return { type: "datetime", source: "regex-datetime" };
  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) return { type: "email", source: "regex-email" };
  if (/^\+?[\d\s\-\(\)]{7,}$/.test(trimmed)) return { type: "tel", source: "regex-tel" };
  if (/^https?:\/\/\S+$/.test(trimmed)) return { type: "url", source: "regex-url" };
  if (/^(true|false)$/i.test(trimmed)) return { type: "boolean", source: "regex-bool" };
  if (/^\d+(\.\d+)?$/.test(trimmed)) return { type: "number", source: "regex-number" };
  try {
    JSON.parse(trimmed);
    return { type: "json", source: "regex-json" };
  } catch (e) {}
  return { type: "text", source: "fallback" };
};

const defaultFormatForType = (type) => {
  switch (type) {
    case "date":
      return "YYYY-MM-DD";
    case "time":
      return "HH:mm";
    case "datetime":
      return "YYYY-MM-DDTHH:mm:ssZ";
    case "number":
    case "integer":
      return "integer";
    case "float":
      return "decimal";
    case "boolean":
      return "true_false";
    default:
      return null;
  }
};

const inferFieldFormat = (value, type) => {
  if (!type) return null;
  if (isPlaceholder(value)) return defaultFormatForType(type);
  if (value === undefined || value === null) return defaultFormatForType(type);
  const s = typeof value === "string" ? value.trim() : String(value);

  if (type === "date") {
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return "YYYY-MM-DD";
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(s)) return "MM/DD/YYYY";
    if (/^\d{2}-\d{2}-\d{4}$/.test(s)) return "MM-DD-YYYY";
    if (/^\d{2}\.\d{2}\.\d{4}$/.test(s)) return "DD.MM.YYYY";
    if (/^\d{1,2} [A-Za-z]{3} \d{4}$/.test(s)) return "D MMM YYYY";
    if (/^\d{1,2} [A-Za-z]+ \d{4}$/.test(s)) return "D MMMM YYYY";
    return defaultFormatForType(type);
  }
  if (type === "time") {
    if (/^\d{2}:\d{2}:\d{2}$/.test(s)) return "HH:mm:ss";
    if (/^\d{2}:\d{2}$/.test(s)) return "HH:mm";
    if (/^\d{1,2}:\d{2}\s?(AM|PM)$/i.test(s)) return "hh:mm A";
    return defaultFormatForType(type);
  }
  if (type === "datetime") {
    if (/T\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}:\d{2})?$/.test(s)) return "YYYY-MM-DDTHH:mm:ssZ";
    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(s)) return "YYYY-MM-DD HH:mm:ss";
    if (/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}$/.test(s)) return "MM/DD/YYYY HH:mm";
    return defaultFormatForType(type);
  }
  if (type === "number" || type === "integer" || type === "float") {
    if (/^-?\d+$/.test(s)) return "integer";
    if (/^-?\d+\.\d{2}$/.test(s)) return "decimal-2";
    if (/^-?\d+\.\d+$/.test(s)) return "decimal";
    return defaultFormatForType(type);
  }
  if (type === "boolean") {
    if (/^(true|false)$/i.test(s)) return "true_false";
    if (/^(1|0)$/.test(s)) return "one_zero";
    if (/^(yes|no)$/i.test(s)) return "yes_no";
    return defaultFormatForType(type);
  }
  return null;
};

const deriveFieldsFromApiConfig = (apiCfg, opts = {}) => {
  const debug = opts.debug || false;
  const trace = [];

  if (!apiCfg) {
    return { fields: [], trace, confidence: "none", reason: "no-api-config" };
  }

  const placeholderNames = new Set();
  const template = apiCfg.payload_template || "{}";
  const regex = /\{\{\s*([^{}]+?)\s*\}\}/g;
  let match;
  while ((match = regex.exec(template)) !== null) {
    placeholderNames.add(match[1]);
  }

  const urlMatches = (apiCfg.url || "").match(/\{\{\s*(\w+)\s*\}\}/g);
  if (urlMatches) {
    urlMatches.forEach((m) => {
      const name = m.replace(/[\{\}\s]/g, "");
      placeholderNames.add(name);
    });
  }

  const queryParams = apiCfg.query_params || {};
  Object.entries(queryParams).forEach(([key, value]) => {
    placeholderNames.add(key);
    const valStr = String(value);
    let vMatch;
    while ((vMatch = regex.exec(valStr)) !== null) {
      placeholderNames.add(vMatch[1]);
    }
  });

  const originalCurl = apiCfg.original_curl_config;
  const originalFields =
    originalCurl?.payload ?? apiCfg.original_field_values ?? {};
  const originalQueryParams =
    originalCurl?.queryParams ?? apiCfg.original_query_param_values ?? {};

  const fields = [];
  const confidenceCounts = { high: 0, low: 0, placeholder: 0 };

  for (const name of placeholderNames) {
    const rawConcreteValue =
      originalFields[name] ?? originalQueryParams[name] ?? undefined;
    const usableConcreteValue = isPlaceholder(rawConcreteValue)
      ? undefined
      : rawConcreteValue;

    let inferred;
    let entryConfidence;

    if (usableConcreteValue !== undefined) {
      inferred = inferFieldType(usableConcreteValue);
      entryConfidence = "high";
      confidenceCounts.high += 1;
    } else {
      const escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      const quotedPattern = new RegExp(`"\\{\\{\\s*${escapedName}\\s*\\}\\}"`);
      const isQuoted = quotedPattern.test(template);
      inferred = {
        type: isQuoted ? "text" : "number",
        source: isQuoted ? "quoted-placeholder" : "bare-placeholder",
      };
      entryConfidence = "low";
      confidenceCounts.low += 1;
      if (isPlaceholder(rawConcreteValue)) {
        confidenceCounts.placeholder += 1;
      }
    }

    const inferredFormat = inferFieldFormat(usableConcreteValue, inferred.type);

    if (debug) {
      trace.push({
        field_name: name,
        raw_concrete_value: rawConcreteValue,
        usable_concrete_value: usableConcreteValue,
        is_placeholder: isPlaceholder(rawConcreteValue),
        inferred_type: inferred.type,
        inferred_format: inferredFormat,
        inferred_source: inferred.source,
        confidence: entryConfidence,
      });
    }

    const fieldObject = {
      field_name: name,
      label: name.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
      type: inferred.type,
      required: true,
      placeholder: "",
      _type_source: inferred.source,
      _type_confidence: entryConfidence,
    };

    if (inferredFormat) {
      fieldObject.format = inferredFormat;
    }

    fields.push(fieldObject);
  }

  const overallConfidence =
    confidenceCounts.high > 0 && confidenceCounts.low === 0
      ? "high"
      : confidenceCounts.high === 0 && confidenceCounts.low > 0
        ? "low"
        : confidenceCounts.high > 0 && confidenceCounts.low > 0
          ? "mixed"
          : "none";

  return {
    fields,
    trace,
    confidence: overallConfidence,
    confidenceCounts,
    placeholderNames: Array.from(placeholderNames),
  };
};

const extractFieldsFromChain = (chain, apiConfigs) => {
  if (!chain || !chain.root || !chain.root.api_config_id) return [];
  const rootConfig = apiConfigs.find(
    (cfg) => cfg.api_config_id === chain.root.api_config_id,
  );
  if (!rootConfig || !rootConfig.api_config) return [];
  const { fields } = deriveFieldsFromApiConfig(rootConfig.api_config);
  return fields;
};

const InfoTooltip = ({ text, children }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  return (
    <span
      style={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
      }}
    >
      <span
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        style={{
          cursor: "help",
          color: "#666",
          marginLeft: "6px",
          display: "inline-flex",
          alignItems: "center",
        }}
      >
        <FaInfoCircle size={14} />
      </span>
      {showTooltip && (
        <div
          style={{
            position: "absolute",
            bottom: "calc(100% + 8px)",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#333",
            color: "white",
            padding: "8px 12px",
            borderRadius: "6px",
            fontSize: "12px",
            maxWidth: "280px",
            width: "max-content",
            textAlign: "left",
            zIndex: 100,
            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
            pointerEvents: "none",
            whiteSpace: "normal",
          }}
        >
          {text}
          <div
            style={{
              position: "absolute",
              top: "100%",
              left: "50%",
              transform: "translateX(-50%)",
              border: "6px solid transparent",
              borderTopColor: "#333",
            }}
          />
        </div>
      )}
      {children}
    </span>
  );
};

const RecentBatchesPanel = ({
  batches,
  loading,
  expanded,
  onToggle,
  onRefresh,
  wiredKeys,
  onWireNow,
}) => {
  if (!batches || batches.length === 0) return null;

  return (
    <div
      style={{
        marginBottom: 24,
        border: "1px solid #e2e8f0",
        borderRadius: 8,
        background: "#f8fafc",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          padding: "12px 16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          borderBottom: expanded ? "1px solid #e2e8f0" : "none",
        }}
        onClick={onToggle}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <span style={{ color: "#64748b" }}>
            {expanded ? <FaChevronDown size={11} /> : <FaChevronRight size={11} />}
          </span>
          <strong style={{ fontSize: 14, color: "#0f172a" }}>
            Recent suggestion batches
          </strong>
          <span style={{ fontSize: 12, color: "#64748b" }}>
            {loading
              ? "Refreshing…"
              : `${batches.length} batch${batches.length === 1 ? "" : "es"}`}
          </span>
        </div>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onRefresh();
          }}
          disabled={loading}
          style={{
            padding: "4px 10px",
            background: "#fff",
            border: "1px solid #cbd5e1",
            borderRadius: 4,
            cursor: loading ? "not-allowed" : "pointer",
            fontSize: 12,
            opacity: loading ? 0.6 : 1,
            display: "inline-flex",
            alignItems: "center",
            gap: 4,
          }}
        >
          <FaSyncAlt size={10} /> Refresh
        </button>
      </div>

      {expanded && (
        <div style={{ padding: "8px 0" }}>
          {batches.map((b) => {
            const completedSlots = (b.slots || []).filter(
              (s) => s.suggestion_status === "completed",
            );
            const failedSlots = (b.slots || []).filter(
              (s) => s.suggestion_status === "failed",
            );
            const pendingSlots = (b.slots || []).filter(
              (s) => s.suggestion_status === "pending",
            );
            const unwiredCount = completedSlots.filter(
              (s) => !wiredKeys.has(s.intent_key),
            ).length;
            const wiredCount = completedSlots.length - unwiredCount;

            return (
              <div
                key={b.batch_id}
                style={{ padding: "10px 16px", borderTop: "1px solid #f1f5f9" }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    flexWrap: "wrap",
                  }}
                >
                  <span
                    style={{
                      fontSize: 11,
                      fontWeight: 600,
                      padding: "2px 8px",
                      borderRadius: 4,
                      background:
                        b.status === "completed"
                          ? "#dcfce7"
                          : b.status === "partial"
                            ? "#fef3c7"
                            : b.status === "failed"
                              ? "#fee2e2"
                              : "#e2e8f0",
                      color:
                        b.status === "completed"
                          ? "#166534"
                          : b.status === "partial"
                            ? "#92400e"
                            : b.status === "failed"
                              ? "#991b1b"
                              : "#475569",
                    }}
                  >
                    {b.status}
                  </span>
                  <span style={{ fontSize: 12, color: "#475569" }}>
                    {b.created_at}
                  </span>
                  <span style={{ fontSize: 12, color: "#475569" }}>
                    · {completedSlots.length}/{b.total} generated
                    {failedSlots.length > 0 && (
                      <span style={{ color: "#b91c1c" }}>
                        {" "}
                        · {failedSlots.length} failed
                      </span>
                    )}
                    {pendingSlots.length > 0 && (
                      <span style={{ color: "#92400e" }}>
                        {" "}
                        · {pendingSlots.length} pending
                      </span>
                    )}
                    {completedSlots.length > 0 && (
                      <span
                        style={{
                          color: unwiredCount > 0 ? "#92400e" : "#166534",
                        }}
                      >
                        {" "}
                        · {unwiredCount} to wire, {wiredCount} wired
                      </span>
                    )}
                  </span>
                </div>

                {completedSlots.length > 0 && (
                  <div
                    style={{
                      marginTop: 8,
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 6,
                    }}
                  >
                    {completedSlots.map((s) => {
                      const isWired = wiredKeys.has(s.intent_key);
                      return (
                        <button
                          key={s.intent_key}
                          onClick={() => !isWired && onWireNow(s.intent_key)}
                          disabled={isWired}
                          title={
                            isWired
                              ? "Already wired — click Modify on the card below"
                              : `Wire "${s.display_name || s.intent_key}"`
                          }
                          style={{
                            padding: "4px 10px",
                            fontSize: 12,
                            borderRadius: 4,
                            border: `1px solid ${isWired ? "#86efac" : "#bfdbfe"}`,
                            background: isWired ? "#ecfdf5" : "#eff6ff",
                            color: isWired ? "#166534" : "#1e40af",
                            cursor: isWired ? "default" : "pointer",
                          }}
                        >
                          {isWired ? "✓ " : "→ "}
                          {s.display_name || s.intent_key}
                        </button>
                      );
                    })}
                  </div>
                )}

                {failedSlots.length > 0 && (
                  <div style={{ marginTop: 8 }}>
                    {failedSlots.map((s) => (
                      <div
                        key={s.slot}
                        style={{
                          padding: "8px 10px",
                          background: "#fef2f2",
                          border: "1px solid #fecaca",
                          borderRadius: 4,
                          marginBottom: 4,
                          fontSize: 12,
                          color: "#7f1d1d",
                        }}
                      >
                        <strong>Slot {s.slot + 1} failed.</strong>{" "}
                        {s.suggestion_error || "No reason recorded."}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default function IntentIndex({ appData, onAppDataPatch }) {
  console.log("appDataddddddd", appData);

  const log = useCallback((message, data) => {
    console.log(`[mission::orchestration] ${message}`, data ?? "");
  }, []);

  const appNameRef = useRef(appData?.app_name);
  const regionRef = useRef(appData?.region?.toLowerCase());
  const prevDerivedFieldsRef = useRef({});
  const warnedIntentsRef = useRef(new Set());

  const [aiAgentBotEnabled, setAiAgentBotEnabled] = useState(
    appData?.ai_agent_bot_enabled ?? false,
  );
  const [initialAiAgentBotEnabled, setInitialAiAgentBotEnabled] = useState(
    appData?.ai_agent_bot_enabled ?? false,
  );

  const [customIntentUiLayout, setCustomIntentUiLayout] = useState(
    appData?.custom_intent_ui_layout ?? "stack",
  );
  const [initialCustomIntentUiLayout, setInitialCustomIntentUiLayout] =
    useState(appData?.custom_intent_ui_layout ?? "stack");

  const [aiAgentBotUpdating, setAiAgentBotUpdating] = useState(false);

  useEffect(() => {
    setAiAgentBotEnabled(appData?.ai_agent_bot_enabled ?? false);
    setInitialAiAgentBotEnabled(appData?.ai_agent_bot_enabled ?? false);
    setCustomIntentUiLayout(appData?.custom_intent_ui_layout ?? "stack");
    setInitialCustomIntentUiLayout(
      appData?.custom_intent_ui_layout ?? "stack",
    );
  }, [appData?.ai_agent_bot_enabled, appData?.custom_intent_ui_layout]);

  const hasAiBotChanges =
    aiAgentBotEnabled !== initialAiAgentBotEnabled ||
    customIntentUiLayout !== initialCustomIntentUiLayout;

  const handleUpdateAiBotToggle = async () => {
    if (!hasAiBotChanges || aiAgentBotUpdating) return;

    setAiAgentBotUpdating(true);
    try {
      const token = localStorage.getItem("token");
      const region_prefix = appData.region.toLowerCase();

      const payload = {
        ai_agent_bot_enabled: aiAgentBotEnabled,
        custom_intent_ui_layout: customIntentUiLayout,
      };

      const updateAppResponse = await fetch(
        `https://${region_prefix}.apps2.${backend_api_base_url}/update_app?act_type=tenant&app_name=${appData.app_name}`,
        {
          method: "PUT",
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      if (!updateAppResponse.ok) {
        throw new Error("Failed to update AI Agent settings");
      }

      setInitialAiAgentBotEnabled(aiAgentBotEnabled);
      setInitialCustomIntentUiLayout(customIntentUiLayout);

      if (onAppDataPatch) {
        onAppDataPatch({
          ai_agent_bot_enabled: aiAgentBotEnabled,
          custom_intent_ui_layout: customIntentUiLayout,
        });
      }

      openAlert({
        heading: "Updated",
        paragraph: `AI Agent Bot settings saved.`,
        icon: <FaCheckCircle size={28} />,
        iconColor: "#16a34a",
        iconBG: "#dcfce7",
      });
    } catch (err) {
      openAlert({
        heading: "Update failed",
        paragraph: err.message,
        icon: <FaTimesCircle size={28} />,
        iconColor: "#dc2626",
        iconBG: "#fee2e2",
      });
    } finally {
      setAiAgentBotUpdating(false);
    }
  };

  const [isNewSkillModalOpen, setIsNewSkillModalOpen] = useState(false);
  const industry = appData.industry;
  const subIndustry = appData.subIndustry;
  const [globalIntents, setGlobalIntents] = useState([]);
  const [appLevelIntents, setAppLevelIntents] = useState([]);
  const [allIntents, setAllIntents] = useState([]);
  const [botForms, setBotForms] = useState([]);
  const [loadingForms, setLoadingForms] = useState(true);
  const [loadingConfigs, setLoadingConfigs] = useState(true);
  const [loadingAppIntents, setLoadingAppIntents] = useState(false);
  const [error, setError] = useState(null);
  const [kbId, setKbId] = useState(null);
  const [intentDescriptions, setIntentDescriptions] = useState({});
  const [descriptionsLoading, setDescriptionsLoading] = useState(true);
  const [descriptionsError, setDescriptionsError] = useState(null);
  const [intentRecords, setIntentRecords] = useState([]);
  const [formConfigs, setFormConfigs] = useState([]);
  const [apiConfigs, setApiConfigs] = useState([]);
  const [chains, setChains] = useState([]);
  const [editingConfigs, setEditingConfigs] = useState({});
  const [customFieldsMap, setCustomFieldsMap] = useState({});
  const [selectedApiConfigPerIntent, setSelectedApiConfigPerIntent] =
    useState({});
  const [selectedChainPerIntent, setSelectedChainPerIntent] = useState({});
  const [showOnCustomIntentContainerMap, setShowOnCustomIntentContainerMap] =
    useState({});
  const [editingIntents, setEditingIntents] = useState([]);
  const [editSnapshots, setEditSnapshots] = useState({});
  const [togglingIntent, setTogglingIntent] = useState(null);
  const [deletingIntent, setDeletingIntent] = useState(null);
  const [deleteTrigger, setDeleteTrigger] = useState(0);
  const [fieldConfidenceMap, setFieldConfidenceMap] = useState({});
  const [library, setLibrary] = useState([]);
  const [libraryVersion, setLibraryVersion] = useState(0);
  const [libraryLoading, setLibraryLoading] = useState(false);
  const [showPicker, setShowPicker] = useState(false);
  const [pickerTargetPath, setPickerTargetPath] = useState(null);
  const [pinModalTarget, setPinModalTarget] = useState(null);
  const [pinModalMode, setPinModalMode] = useState("pin");

  const [showIconPicker, setShowIconPicker] = useState(false);
  const [iconPickerTarget, setIconPickerTarget] = useState(null);
  const [intentIcons, setIntentIcons] = useState({});

  const [highlightIntent, setHighlightIntent] = useState(null);

  const [recentBatches, setRecentBatches] = useState([]);
  const [recentBatchesLoading, setRecentBatchesLoading] = useState(false);
  const [showBatchPanel, setShowBatchPanel] = useState(true);

  // ⭐ NEW: inline 403 banner on save (P2 — dropdown consumer).
  // Fires when the caller tries to map a form to an unattached tenant
  // api_config or chain. Rendered as a dismissible banner above the
  // card list rather than a popup, so the operator can see which
  // specific intent tripped it while they fix the mapping.
  const [attachmentRefusal, setAttachmentRefusal] = useState(null);

  const [popup, setPopup] = useState({
    isOpen: false,
    variant: "confirm",
    heading: "",
    subtext: "",
    paragraph: "",
    confirmText: "Confirm",
    cancelText: "Cancel",
    icon: null,
    iconColor: "#dc2626",
    iconBG: "#fee2e2",
    onConfirm: null,
    onCancel: null,
  });

  const closePopup = () => {
    setPopup((p) => {
      if (p.onCancel) p.onCancel();
      return { ...p, isOpen: false, onConfirm: null, onCancel: null };
    });
  };

  const openConfirmPopup = ({
    heading,
    subtext = "",
    paragraph = "",
    confirmText = "Confirm",
    cancelText = "Cancel",
    icon = null,
    iconColor = "#dc2626",
    iconBG = "#fee2e2",
    onConfirm,
  }) => {
    setPopup({
      isOpen: true,
      variant: "confirm",
      heading,
      subtext,
      paragraph,
      confirmText,
      cancelText,
      icon,
      iconColor,
      iconBG,
      onConfirm,
      onCancel: null,
    });
  };

  const openAlert = ({
    heading = "",
    subtext = "",
    paragraph = "",
    confirmText = "OK",
    icon = null,
    iconColor = "#16a34a",
    iconBG = "#dcfce7",  }) => {
    setPopup({
      isOpen: true,
      variant: "alert",
      heading,
      subtext,
      paragraph,
      confirmText,
      cancelText: "",
      icon,
      iconColor,
      iconBG,
      onConfirm: () => {
        setPopup((p) => ({
          ...p,
          isOpen: false,
          onConfirm: null,
          onCancel: null,
        }));
      },
      onCancel: null,
    });
  };

  const getAutobotUrl = useCallback(
    (path, queryParams = {}) => {
      const region = appData?.region?.toLowerCase() || "us";
      const stackPrefix = process.env.REACT_APP_STAGE_ENV || "dev";
      const baseUrl = `https://${region}.autobot2.${process.env.REACT_APP_SL_BE_BASE_ENV_PART}`;
      const queryString = new URLSearchParams(queryParams).toString();
      return `${baseUrl}/${stackPrefix}${path}${queryString ? `?${queryString}` : ""}`;
    },
    [appData?.region],
  );

  const callAutobotApi = useCallback(
    async (path, method = "GET", body = null, queryParams = {}) => {
      const token = localStorage.getItem("token");
      const url = getAutobotUrl(path, queryParams);
      const options = {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: token || "",
        },
      };
      if (body && (method === "POST" || method === "PUT" || method === "PATCH")) {
        options.body = JSON.stringify(body);
      }
      log(`Calling AutoBot: ${method} ${url}`);
      const response = await fetch(url, options);
      if (!response.ok) {
        throw new Error(
          `API call failed: ${response.status} ${response.statusText}`,
        );
      }
      const data = await response.json();
      log(`AutoBot response:`, data);
      return data;
    },
    [getAutobotUrl, log],
  );

  const appLevelFetchedForKbRef = useRef(null);

  const fetchAppLevelIntents = useCallback(async () => {
    const meData = JSON.parse(localStorage.getItem("meData"));
    const tenantId = meData.tenant_info.id;
    const region = appData?.region?.toLowerCase() || "us";
    if (!kbId || !tenantId) return;
    setLoadingAppIntents(true);
    try {
      const token = localStorage.getItem("token");
      const url = getAutobotUrl(`/ai_ingest_sys`, {
        task: `app-intents/${tenantId}/${kbId}`,
        region,
      });
      const response = await fetch(url, {
        headers: {
          Authorization: token || "",
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        setAppLevelIntents([]);
        return;
      }
      const data = await response.json();
      let parsedData = data;
      if (data.statusCode && data.body) {
        parsedData =
          typeof data.body === "string" ? JSON.parse(data.body) : data.body;
      }
      let intents = [];
      if (parsedData.intents && Array.isArray(parsedData.intents))
        intents = parsedData.intents;
      else if (parsedData.data && Array.isArray(parsedData.data))
        intents = parsedData.data;
      else if (Array.isArray(parsedData)) intents = parsedData;
      setAppLevelIntents(intents);
    } catch (error) {
      setAppLevelIntents([]);
    } finally {
      setLoadingAppIntents(false);
    }
  }, [kbId, appData?.region, getAutobotUrl]);

  const fetchRecentBatches = useCallback(async () => {
    if (!kbId) return;
    const meData = JSON.parse(localStorage.getItem("meData") || "{}");
    const tenantId = meData?.tenant_info?.id;
    if (!tenantId) return;
    const region = appData?.region?.toLowerCase() || "us";
    setRecentBatchesLoading(true);
    try {
      const token = localStorage.getItem("token");
      const url = getAutobotUrl(`/ai_ingest_sys`, {
        task: "custom-intents/suggest-batches/recent",
        tenant_id: tenantId,
        kb_id: kbId,
        region,
        limit: 5,
      });
      const resp = await fetch(url, {
        headers: {
          Authorization: token || "",
          "Content-Type": "application/json",
        },
      });
      if (!resp.ok) return;
      const data = await resp.json();
      const inner =
        data?.batch
          ? data
          : data?.body && typeof data.body === "object"
            ? data.body
            : data;
      const batches = inner?.batches || [];
      setRecentBatches(batches);
    } catch (_) {
    } finally {
      setRecentBatchesLoading(false);
    }
  }, [kbId, appData?.region, getAutobotUrl]);

  const globalFetchedForKeyRef = useRef(null);

  const fetchGlobalIntents = useCallback(async () => {
    const region = appData?.region?.toLowerCase();
    if (!region) {
      setDescriptionsLoading(false);
      return;
    }
    try {
      const token = localStorage.getItem("token");
      const stackPrefix = process.env.REACT_APP_STAGE_ENV || "dev";
      const domainBase = process.env.REACT_APP_SL_BE_BASE_ENV_PART;
      const url = `https://${region}.autobot2.${domainBase}/${stackPrefix}/ai_query_sys?task=global_intents&industry=${industry}`;
      const response = await fetch(url, {
        headers: {
          Authorization: token || "",
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      const json = await response.json();
      let data = json;
      if (json.statusCode && json.body)
        data =
          typeof json.body === "string" ? JSON.parse(json.body) : json.body;
      if (data.body && data.body.data) data = data.body;
      if (data.status === "success" && data.data)
        setIntentDescriptions(data.data);
      else {
        setIntentDescriptions({});
        if (data.message) setDescriptionsError(data.message);
      }
    } catch (err) {
      setDescriptionsError(err.message);
      setIntentDescriptions({});
    } finally {
      setDescriptionsLoading(false);
    }
  }, [appData?.region, industry]);

  const libraryFetchedForKeyRef = useRef(null);

  useEffect(() => {
    if (!appData?.app_name) return;
    const key = `${appData.app_name}|${appData.region}|${appData.library_version ?? "0"}`;
    if (libraryFetchedForKeyRef.current === key) return;
    libraryFetchedForKeyRef.current = key;

    let cancelled = false;
    (async () => {
      setLibraryLoading(true);
      try {
        const result = await fetchUiFieldComponentsLibrary({
          appName: appData.app_name,
          region: appData.region,
          baseUrl: backend_api_base_url,
        });
        if (cancelled) return;
        setLibrary(
          Array.isArray(result.components) ? result.components : [],
        );
        setLibraryVersion(Number.isFinite(result.version) ? result.version : 0);
      } catch (err) {
        if (cancelled) return;
        setLibrary([]);
        setLibraryVersion(0);
      } finally {
        if (!cancelled) setLibraryLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [appData?.app_name, appData?.region, appData?.library_version]);

  const fetchBackendConfigs = useCallback(async () => {
    log("Fetching backend configs started");
    setLoadingConfigs(true);
    const token = localStorage.getItem("token");
    if (!token || !kbId || !appData?.app_name) {
      setLoadingConfigs(false);
      return;
    }
    const payload = JSON.parse(atob(token.split(".")[1]));
    const tenantId = appData.tenant_info.id;
    const tenantName = payload.tenant_id;
    const region = appData.region.toLowerCase();

    try {
      const intUrl = getAutobotUrl(`/ai_ingest_sys`, {
        task: `custom-intents/${tenantId}/${kbId}`,
        region,
      });
      const intResp = await fetch(intUrl, {
        headers: { Authorization: token || "" },
      });

      if (intResp.ok) {
        const intData = await intResp.json();
        let parsedData = intData;
        if (intData.body && typeof intData.body === "string")
          parsedData = JSON.parse(intData.body);
        else if (intData.body && typeof intData.body === "object")
          parsedData = intData.body;

        let intents = [];
        if (Array.isArray(parsedData)) intents = parsedData;
        else if (parsedData.intents && Array.isArray(parsedData.intents))
          intents = parsedData.intents;
        else if (parsedData.data && Array.isArray(parsedData.data))
          intents = parsedData.data;
        setIntentRecords(intents);
      } else setIntentRecords([]);

      const cfgUrl = `https://${region}.autobot2.${backend_api_base_url}/get_form_api_config?tenant_id=${tenantName}&app_name=${appData.app_name}`;
      const cfgResp = await fetch(cfgUrl, {
        headers: { Authorization: token },
      });
      if (cfgResp.ok) {
        const cfgData = await cfgResp.json();
        setFormConfigs(cfgData.configs || []);
      } else setFormConfigs([]);

      const appNameParam = encodeURIComponent(appData.app_name);
      const apiConfigResp = await fetch(
        `https://${region}.autobot2.${backend_api_base_url}/api_config?app_name=${appNameParam}&include_tenant=true`,
        { headers: { Authorization: token } },
      );
      if (apiConfigResp.ok) {
        const data = await apiConfigResp.json();
        setApiConfigs(
          (data.configs || []).filter((cfg) => cfg.api_type === "REGULAR"),
        );
      }

      const chainsResp = await fetch(
        `https://${region}.autobot2.${backend_api_base_url}/chain?app_name=${appNameParam}&include_tenant=true`,
        { headers: { Authorization: token } },
      );
      if (chainsResp.ok) {
        const data = await chainsResp.json();
        setChains(data.chains || []);
      }
    } catch (err) {
      log("Error fetching backend configs", err);
    } finally {
      setLoadingConfigs(false);
    }
  }, [kbId, appData?.app_name, appData?.region, log, getAutobotUrl]);

  const handleToggleActive = async (intentName, currentStatus) => {
    const meData = JSON.parse(localStorage.getItem("meData"));
    const tenantId = meData.tenant_info.id;
    const region = appData?.region?.toLowerCase() || "unknown";
    setTogglingIntent(intentName);

    try {
      const token = localStorage.getItem("token");
      const intentRecord = intentRecords.find(
        (r) => r.intent_type === intentName,
      );
      const isCurrentlyDraft = intentRecord?.draft === true;
      const isTurningOn = !currentStatus;
      const queryParams = {
        task: `custom-intents/${tenantId}/${kbId}/${intentName}/toggle-active`,
        region,
      };
      if (isCurrentlyDraft && isTurningOn) queryParams.clear_draft = "true";

      const url = getAutobotUrl(`/ai_ingest_sys`, queryParams);
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: token || "",
        },
      });
      if (!response.ok)
        throw new Error(`Failed to toggle active status: ${response.status}`);
      const data = await response.json();

      if (data.success) {
        setIntentRecords((prev) =>
          prev.map((record) => {
            if (record.intent_type !== intentName) return record;
            const next = { ...record, is_active: data.is_active };
            if (isCurrentlyDraft && isTurningOn && data.draft === undefined)
              next.draft = false;
            else if (data.draft !== undefined) next.draft = data.draft;
            return next;
          }),
        );
      }
    } catch (error) {
      openAlert({
        heading: "Couldn't update this skill",
        paragraph: error.message,
        icon: <FaTimesCircle size={28} />,
        iconColor: "#dc2626",
        iconBG: "#fee2e2",
      });
    } finally {
      setTogglingIntent(null);
    }
  };

  const handleDeleteIntent = (intentName) => {
    const region = appData?.region?.toLowerCase() || "unknown";
    let dynTenantId = appData?.tenant_id || null;
    if (!dynTenantId) {
      try {
        const token = localStorage.getItem("token");
        if (token)
          dynTenantId =
            JSON.parse(atob(token.split(".")[1]))?.tenant_id || null;
      } catch (_) {}
    }
    let authTenantId = null;
    try {
      authTenantId =
        JSON.parse(localStorage.getItem("meData"))?.tenant_info?.id || null;
    } catch (_) {}

    const intentRecord = intentRecords.find(
      (r) => r.intent_type === intentName,
    );
    const formUuid = intentRecord?.form_uuid || null;

    openConfirmPopup({
      heading: "Remove the API connection?",
      subtext: `Skill: "${intentName}"`,
      paragraph:
        "This will remove the API/Chain mapping for this skill. The skill itself stays in the library, and can be re-wired later.",
      confirmText: "Remove",
      cancelText: "Cancel",
      icon: <RiDeleteBin6Line size={28} />,
      iconColor: "#dc2626",
      iconBG: "#fee2e2",
      onConfirm: async () => {
        closePopup();
        setDeletingIntent(intentName);

        try {
          const token = localStorage.getItem("token");
          const apiBaseUrl = `https://${region}.autobot2.${backend_api_base_url}`;

          if (formUuid) {
            const cfgDelUrl = `${apiBaseUrl}/delete_form_api_config?tenant_id=${encodeURIComponent(dynTenantId)}&form_uuid=${encodeURIComponent(formUuid)}`;
            const cfgDelResp = await fetch(cfgDelUrl, {
              method: "DELETE",
              headers: { Authorization: token || "" },
            });
            if (!cfgDelResp.ok)
              throw new Error(
                `Failed to remove form mapping (HTTP ${cfgDelResp.status}). The intent was NOT deleted. Please retry; if this persists, contact support with form_uuid=${formUuid}.`,
              );

            let body = null;
            try {
              body = await cfgDelResp.json();
            } catch (_) {
              throw new Error(
                `The form mapping was not confirmed as deleted (HTTP ${cfgDelResp.status}, no verifiable body) for form_uuid="${formUuid}". The intent was NOT deleted, so you can retry safely.`,
              );
            }

            const newTableRows = body?.deleted?.new_table_rows;
            if (typeof newTableRows !== "number" || newTableRows < 1) {
              throw new Error(
                `The form mapping was not confirmed as deleted (new_table_rows=${JSON.stringify(newTableRows)}) under tenant_id="${dynTenantId}" and form_uuid="${formUuid}". The intent was NOT deleted, so you can retry safely.`,
              );
            }
          }

          const queryParams = {
            task: `custom-intents/${authTenantId}/${kbId}/${intentName}`,
            region,
          };
          const url = getAutobotUrl(`/ai_ingest_sys`, queryParams);
          const response = await fetch(url, {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              Authorization: token || "",
            },
          });
          if (!response.ok)
            throw new Error(`Failed to delete intent: ${response.status}`);

          const data = await response.json();
          let responseBody = data;
          if (data.statusCode && data.body)
            responseBody =
              typeof data.body === "string"
                ? JSON.parse(data.body)
                : data.body;
          if (responseBody?.success !== true)
            throw new Error(
              responseBody?.message ||
                responseBody?.error ||
                "Unknown error",
            );

          setIntentRecords((prev) =>
            prev.filter((record) => record.intent_type !== intentName),
          );
          if (formUuid)
            setFormConfigs((prev) =>
              prev.filter((cfg) => cfg.form_uuid !== formUuid),
            );
          setSelectedApiConfigPerIntent((prev) => ({
            ...prev,
            [intentName]: "",
          }));
          setSelectedChainPerIntent((prev) => ({
            ...prev,
            [intentName]: "",
          }));
          setCustomFieldsMap((prev) => ({ ...prev, [intentName]: [] }));
          setShowOnCustomIntentContainerMap((prev) => {
            const n = { ...prev };
            delete n[intentName];
            return n;
          });
          setEditingIntents((prev) =>
            prev.filter((name) => name !== intentName),
          );
          setEditSnapshots((prev) => {
            const n = { ...prev };
            delete n[intentName];
            return n;
          });
          setDeleteTrigger((prev) => prev + 1);

          openAlert({
            heading: "Connection removed",
            paragraph: `Successfully removed the connection for "${intentName}".`,
            icon: <FaCheckCircle size={28} />,
            iconColor: "#16a34a",
            iconBG: "#dcfce7",
          });
        } catch (error) {
          openAlert({
            heading: "Couldn't remove the connection",
            paragraph: error.message,
            icon: <FaTimesCircle size={28} />,
            iconColor: "#dc2626",
            iconBG: "#fee2e2",
          });
        } finally {
          setDeletingIntent(null);
        }
      },
    });
  };

  const handleNewSkillSaved = useCallback(
    (newRecord) => {
      if (newRecord?.is_app_level) {
        setAppLevelIntents((prev) => {
          const filtered = prev.filter(
            (ai) => ai.intent_key !== newRecord.intent_key,
          );
          return [...filtered, newRecord];
        });
      } else {
        setIntentRecords((prev) => {
          const filtered = prev.filter(
            (r) => r.intent_type !== newRecord.intent_type,
          );
          return [...filtered, newRecord];
        });
        if (newRecord?.bot_icon) {
          setIntentIcons((prev) => ({
            ...prev,
            [newRecord.intent_type]: newRecord.bot_icon,
          }));
        }
        fetchBackendConfigs();
      }
      fetchRecentBatches();
    },
    [fetchBackendConfigs, fetchRecentBatches],
  );

  const handleDraftsCreated = useCallback(() => {
    appLevelFetchedForKbRef.current = null;
    fetchAppLevelIntents();
    fetchRecentBatches();
  }, [fetchAppLevelIntents, fetchRecentBatches]);

  const wireIntentNow = useCallback((intentKey) => {
    setIsNewSkillModalOpen(false);
    setHighlightIntent(intentKey);
    setTimeout(() => {
      const el = document.querySelector(`[data-intent-key="${intentKey}"]`);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 100);
    setTimeout(
      () => setHighlightIntent((cur) => (cur === intentKey ? null : cur)),
      3000,
    );
  }, []);

  const extractAllForms = (node, depth = 0, maxDepth = 10) => {
    if (!node || typeof node !== "object" || depth > maxDepth) return [];
    let foundForms = [];
    if (node.type === "form_type" && node.text) {
      const form = {
        form_name: node.text,
        fields: [],
        uuid: node.uuid || `form-${Date.now()}-${Math.random()}`,
        original_node: node,
        depth,
      };
      if (Array.isArray(node.fields)) {
        node.fields.forEach((field) => {
          if (field.type === "field_type") {
            const fieldName =
              field.field ||
              field.text?.toLowerCase().replace(/\s+/g, "_") ||
              "field_" + Date.now();
            form.fields.push({
              label: field.text || "Untitled Field",
              type: field.fieldType || "text",
              required: field.required || false,
              placeholder: field.placeholder || "",
              uuid: field.uuid,
              field_name: fieldName,
            });
          }
        });
      }
      foundForms.push(form);
    }
    const possibleChildrenProps = [
      "subQuestions",
      "answers",
      "fields",
      "children",
      "nodes",
      "items",
      "options",
      "sub_nodes",
    ];
    for (const prop of possibleChildrenProps) {
      if (Array.isArray(node[prop])) {
        node[prop].forEach((child) => {
          foundForms = [
            ...foundForms,
            ...extractAllForms(child, depth + 1, maxDepth),
          ];
        });
      }
    }
    Object.keys(node).forEach((key) => {
      if (
        typeof node[key] === "object" &&
        node[key] !== null &&
        !possibleChildrenProps.includes(key) &&
        key !== "uuid" &&
        key !== "text" &&
        key !== "type"
      ) {
        foundForms = [
          ...foundForms,
          ...extractAllForms(node[key], depth + 1, maxDepth),
        ];
      }
    });
    return foundForms;
  };

  useEffect(() => {
    const fetchBotContent = async () => {
      const appName = appData?.app_name;
      const region = appData?.region?.toLowerCase();
      appNameRef.current = appName;
      regionRef.current = region;
      try {
        setLoadingForms(true);
        setError(null);
        const token = localStorage.getItem("token");
        if (!token) throw new Error("No token found in localStorage");
        const tenantId = JSON.parse(atob(token.split(".")[1])).tenant_id;
        const response = await fetch(
          `https://${region}.autobot2.${backend_api_base_url}/get_bot_content?app_name=${appName}&tenant_id=${tenantId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: token,
            },
          },
        );
        if (!response.ok)
          throw new Error(`Bot content fetch failed: ${response.status}`);
        const data = await response.json();
        setKbId(data?.bot_payload?.kb_id || `${tenantId}__${appName}`);
        const botPayload = data?.bot_payload;
        let allForms = [];
        if (botPayload) {
          const topLevelSections = [
            "FAQ",
            "WelcomeMessage",
            "FallbackMessage",
            "Intents",
            "Contexts",
          ];
          for (const section of topLevelSections) {
            if (botPayload[section])
              allForms = [
                ...allForms,
                ...extractAllForms(botPayload[section]),
              ];
          }
          allForms = [...allForms, ...extractAllForms(botPayload)];
        }
        const uniqueForms = [];
        const uuidSet = new Set();
        for (const form of allForms) {
          if (!uuidSet.has(form.uuid)) {
            uuidSet.add(form.uuid);
            uniqueForms.push(form);
          }
        }
        setBotForms(uniqueForms);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoadingForms(false);
      }
    };
    if (appData?.app_name) fetchBotContent();
  }, [appData?.app_name, appData?.region]);

  useEffect(() => {
    setGlobalIntents(getIntentsForIndustry(industry, subIndustry));
  }, [industry, subIndustry]);

  useEffect(() => {
    const key = `${appData?.region}|${industry}`;
    if (globalFetchedForKeyRef.current === key) return;
    globalFetchedForKeyRef.current = key;
    fetchGlobalIntents();
  }, [appData?.region, industry]);

  useEffect(() => {
    if (!kbId) return;
    if (appLevelFetchedForKbRef.current === kbId) return;
    appLevelFetchedForKbRef.current = kbId;
    fetchAppLevelIntents();
    fetchRecentBatches();
  }, [kbId, fetchRecentBatches]);

  useEffect(() => {
    const mappedAppIntents = appLevelIntents.map((appIntent) => ({
      name: appIntent.intent_key,
      display_name:
        appIntent.display_name ||
        appIntent.intent_key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
      is_app_level: true,
      description: appIntent.description,
      examples: appIntent.examples || [],
      rules: appIntent.rules || [],
      _suggested_from_api_config_id:
        appIntent.suggested_from_api_config_id || null,
      _suggested_from_chain_id: appIntent.suggested_from_chain_id || null,
    }));

    const customIntents = intentRecords.map((r) => ({
      name: r.intent_type,
      display_name: r.intent_type
        .replace(/_/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase()),
      is_app_level: false,
      is_custom: true,
      description: r.description || "",
      examples: r.examples || [],
      rules: r.rules || [],
    }));

    const seen = new Set();
    const merged = [];
    for (const g of globalIntents) {
      if (!seen.has(g.name)) {
        seen.add(g.name);
        merged.push(g);
      }
    }
    for (const a of mappedAppIntents) {
      if (!seen.has(a.name)) {
        seen.add(a.name);
        merged.push(a);
      }
    }
    for (const c of customIntents) {
      if (!seen.has(c.name)) {
        seen.add(c.name);
        merged.push(c);
      }
    }
    setAllIntents(merged);
  }, [globalIntents, appLevelIntents, intentRecords]);

  const backendFetchedForKeyRef = useRef(null);

  useEffect(() => {
    if (!kbId) return;
    const key = `${kbId}|${appData?.app_name}`;
    if (backendFetchedForKeyRef.current === key) return;
    backendFetchedForKeyRef.current = key;
    fetchBackendConfigs();
  }, [kbId, appData?.app_name]);

  useEffect(() => {
    if (!allIntents.length) return;
    log("Initializing editing configs from backend data");

    const newConfigs = {};
    const newCustomFields = {};
    const newApiSelections = {};
    const newChainSelections = {};
    const newShowOnContainer = {};

    allIntents.forEach((intent) => {
      const intentRecord = intentRecords.find(
        (r) => r.intent_type === intent.name,
      );

      newConfigs[intent.name] = { form_uuid: "__NA__" };
      newShowOnContainer[intent.name] =
        intentRecord?.show_on_custom_intent_container !== false;

      if (intentRecord) {
        const rawUuid = intentRecord.form_uuid || "";
        if (rawUuid.startsWith("form_na_")) {
          newCustomFields[intent.name] = (
            intentRecord.required_fields || []
          ).map((f) => {
            const mapped = {
              field_name: f.field,
              label: f.label,
              type: f.type,
              required: f.required,
              placeholder: f.placeholder || "",
            };
            if (f.format) mapped.format = f.format;
            if (f.component_id) {
              mapped.component_id = f.component_id;
              if (f.widget_type) mapped.widget_type = f.widget_type;
              if (f.pinned && f.pinned_snapshot) {
                mapped.pinned = true;
                mapped.pinned_snapshot = f.pinned_snapshot;
              }
            }
            return mapped;
          });
        } else {
          newCustomFields[intent.name] = [];
        }
      } else {
        newCustomFields[intent.name] = [];
      }

      let apiConfigId = "";
      let chainId = "";

      if (intentRecord && intentRecord.form_uuid) {
        const mapping = formConfigs.find(
          (c) => c.form_uuid === intentRecord.form_uuid,
        );
        if (mapping) {
          const mappedApiId = mapping.api_config_id || "";
          const mappedChainId = mapping.chain_id || "";
          const apiIsLive =
            mappedApiId && apiConfigs.some((c) => c.api_config_id === mappedApiId);
          const chainIsLive =
            mappedChainId && chains.some((c) => c.chain_id === mappedChainId);
          apiConfigId = apiIsLive ? mappedApiId : "";
          chainId = chainIsLive ? mappedChainId : "";

          if (chainId) {
            const chain = chains.find((c) => c.chain_id === chainId);
            if (chain) {
              const chainFields = extractFieldsFromChain(chain, apiConfigs);
              if (chainFields.length > 0) {
                const currentFields = newCustomFields[intent.name] || [];
                newCustomFields[intent.name] = chainFields.map((newF) => {
                  const existing = currentFields.find(
                    (f) => f.field_name === newF.field_name,
                  );
                  if (!existing) return newF;
                  const preserved = { ...newF };
                  if (existing.component_id) {
                    preserved.component_id = existing.component_id;
                    if (existing.widget_type)
                      preserved.widget_type = existing.widget_type;
                    if (existing.pinned && existing.pinned_snapshot) {
                      preserved.pinned = true;
                      preserved.pinned_snapshot = existing.pinned_snapshot;
                    }
                  }
                  return preserved;
                });
              }
            }
          }
        }
      }
      newApiSelections[intent.name] = apiConfigId;
      newChainSelections[intent.name] = chainId;
    });

    setEditingConfigs(newConfigs);
    setCustomFieldsMap((prev) => {
      const merged = { ...prev };
      for (const [intentName, fields] of Object.entries(newCustomFields)) {
        if ((fields && fields.length > 0) || !merged[intentName])
          merged[intentName] = fields;
      }
      return merged;
    });
    setSelectedApiConfigPerIntent((prev) => ({ ...prev, ...newApiSelections }));
    setSelectedChainPerIntent((prev) => ({ ...prev, ...newChainSelections }));
    setShowOnCustomIntentContainerMap((prev) => {
      const merged = { ...prev };
      for (const [intentName, show] of Object.entries(newShowOnContainer)) {
        if (merged[intentName] === undefined) merged[intentName] = show;
      }
      return merged;
    });

    const newIcons = {};
    intentRecords.forEach((r) => {
      if (r.bot_icon) {
        newIcons[r.intent_type] = r.bot_icon;
      }
    });
    setIntentIcons((prev) => ({ ...prev, ...newIcons }));
  }, [intentRecords, formConfigs, allIntents, chains, apiConfigs]);

  useEffect(() => {
    allIntents.forEach((intent) => {
      const apiConfigId = selectedApiConfigPerIntent[intent.name];
      const chainId = selectedChainPerIntent[intent.name];

      if (chainId) {
        const chain = chains.find((c) => c.chain_id === chainId);
        if (!chain) return;
        const chainFields = extractFieldsFromChain(chain, apiConfigs);
        const currentFields = customFieldsMap[intent.name] || [];
        const mergedChainFields = chainFields.map((newF) => {
          const existing = currentFields.find(
            (f) => f.field_name === newF.field_name,
          );
          if (!existing) return newF;
          const preserved = { ...newF };
          if (existing.component_id) {
            preserved.component_id = existing.component_id;
            if (existing.widget_type)
              preserved.widget_type = existing.widget_type;
            if (existing.pinned && existing.pinned_snapshot) {
              preserved.pinned = true;
              preserved.pinned_snapshot = existing.pinned_snapshot;
            }
          }
          return preserved;
        });

        const prevFields = prevDerivedFieldsRef.current[intent.name];
        const prevFieldNames = new Set(
          (prevFields || []).map((f) => f.field_name),
        );
        const newFieldNames = new Set(
          mergedChainFields.map((f) => f.field_name),
        );
        if (
          prevFieldNames.size !== newFieldNames.size ||
          ![...prevFieldNames].every((name) => newFieldNames.has(name))
        ) {
          prevDerivedFieldsRef.current[intent.name] = mergedChainFields;
          setCustomFieldsMap((prev) => ({
            ...prev,
            [intent.name]: mergedChainFields,
          }));
        }
        return;
      }

      if (!apiConfigId) {
        const prevFields = prevDerivedFieldsRef.current[intent.name];
        if (prevFields && prevFields.length > 0) {
          prevDerivedFieldsRef.current[intent.name] = [];
          setCustomFieldsMap((prev) => ({ ...prev, [intent.name]: [] }));
        }
        return;
      }

      const selectedCfg = apiConfigs.find(
        (cfg) => cfg.api_config_id === apiConfigId,
      );
      const apiCfg = selectedCfg?.api_config;
      if (!apiCfg) return;

      const { fields: newFields, confidence } = deriveFieldsFromApiConfig(
        apiCfg,
        { debug: true },
      );
      setFieldConfidenceMap((prev) =>
        prev[intent.name] === confidence
          ? prev
          : { ...prev, [intent.name]: confidence },
      );

      const currentFields = customFieldsMap[intent.name] || [];
      const merged = newFields.map((newF) => {
        const existing = currentFields.find(
          (f) => f.field_name === newF.field_name,
        );
        if (!existing) return newF;
        const preserved = {
          ...newF,
          label: existing.label ?? newF.label,
          type: existing.type ?? newF.type,
          required:
            existing.required !== undefined
              ? existing.required
              : newF.required,
          placeholder: existing.placeholder ?? newF.placeholder,
        };
        if (existing.type === newF.type && existing.format !== undefined)
          preserved.format = existing.format;
        else if (newF.format !== undefined) preserved.format = newF.format;
        else delete preserved.format;

        if (existing.component_id) {
          preserved.component_id = existing.component_id;
          if (existing.widget_type)
            preserved.widget_type = existing.widget_type;
          if (existing.pinned && existing.pinned_snapshot) {
            preserved.pinned = true;
            preserved.pinned_snapshot = existing.pinned_snapshot;
          }
        }
        return preserved;
      });

      const newFieldNames = new Set(newFields.map((f) => f.field_name));
      const cleaned = merged.filter((f) => newFieldNames.has(f.field_name));
      const prevFields = prevDerivedFieldsRef.current[intent.name];
      if (JSON.stringify(prevFields) !== JSON.stringify(cleaned)) {
        prevDerivedFieldsRef.current[intent.name] = cleaned;
        setCustomFieldsMap((prev) => ({ ...prev, [intent.name]: cleaned }));
      }
    });
  }, [
    apiConfigs,
    chains,
    allIntents,
    selectedApiConfigPerIntent,
    selectedChainPerIntent,
  ]);

  const startEdit = (intentName) => {
    setEditSnapshots((prev) => ({
      ...prev,
      [intentName]: {
        customFields: JSON.parse(
          JSON.stringify(customFieldsMap[intentName] || []),
        ),        apiConfigId: selectedApiConfigPerIntent[intentName] || "",
        chainId: selectedChainPerIntent[intentName] || "",
        showOnCustomIntentContainer:
          showOnCustomIntentContainerMap[intentName] !== false,
        icon: intentIcons[intentName] || "",
      },
    }));
    setEditingIntents((prev) => [...prev, intentName]);
  };

  const cancelEdit = (intentName) => {
    const snapshot = editSnapshots[intentName];
    if (snapshot) {
      setCustomFieldsMap((prev) => ({
        ...prev,
        [intentName]: snapshot.customFields,
      }));
      setSelectedApiConfigPerIntent((prev) => ({
        ...prev,
        [intentName]: snapshot.apiConfigId,
      }));
      setSelectedChainPerIntent((prev) => ({
        ...prev,
        [intentName]: snapshot.chainId,
      }));
      setShowOnCustomIntentContainerMap((prev) => ({
        ...prev,
        [intentName]: snapshot.showOnCustomIntentContainer,
      }));
      setIntentIcons((prev) => ({ ...prev, [intentName]: snapshot.icon }));
    }
    setEditingIntents((prev) => prev.filter((name) => name !== intentName));
    setEditSnapshots((prev) => {
      const n = { ...prev };
      delete n[intentName];
      return n;
    });
  };

  const handleCustomFieldsChange = (intentName, newFields) => {
    setCustomFieldsMap((prev) => ({ ...prev, [intentName]: newFields }));
  };

  const mutateFieldInIntent = (intentName, fieldName, mutator) => {
    setCustomFieldsMap((prev) => {
      const current = prev[intentName] || [];
      const updated = current.map((f) =>
        f.field_name !== fieldName ? f : mutator(f),
      );
      return { ...prev, [intentName]: updated };
    });
  };

  const handlePickerSelect = (component) => {
    if (!pickerTargetPath) {
      setShowPicker(false);
      return;
    }
    const { intentName, fieldName } = pickerTargetPath;

    mutateFieldInIntent(intentName, fieldName, (f) => ({
      ...f,
      component_id: component.component_id,
      widget_type: component.type,
      type: f.type || "text",
      ...(Array.isArray(component.options) && component.options.length > 0
        ? {
            options: component.options.map((o) => ({
              value: o.value,
              label: o.label,
            })),
          }
        : {}),
      ...(component.min !== undefined && component.min !== ""
        ? { min: component.min }
        : {}),
      ...(component.max !== undefined && component.max !== ""
        ? { max: component.max }
        : {}),
      ...(component.step !== undefined && component.step !== ""
        ? { step: component.step }
        : {}),
      pinned: false,
      pinned_snapshot: null,
    }));

    setShowPicker(false);
    setPickerTargetPath(null);
  };

  const handleReimportFromLibrary = (intentName, fieldName) => {
    const field = (customFieldsMap[intentName] || []).find(
      (f) => f.field_name === fieldName,
    );
    if (!field?.component_id) return;
    const comp = library.find((c) => c.component_id === field.component_id);
    if (!comp) return;

    mutateFieldInIntent(intentName, fieldName, (f) => {
      const defaultFmt = defaultFormatForType(comp.type);
      const currentFmtIsValid = f.format && defaultFmt !== null;

      return {
        ...f,
        widget_type: comp.type,
        type: f.type || "text",
        format: currentFmtIsValid ? f.format : defaultFmt || undefined,
        ...(Array.isArray(comp.options) && comp.options.length > 0
          ? {
              options: comp.options.map((o) => ({
                value: o.value,
                label: o.label,
              })),
            }
          : {}),
        ...(comp.min !== undefined && comp.min !== ""
          ? { min: comp.min }
          : {}),
        ...(comp.max !== undefined && comp.max !== ""
          ? { max: comp.max }
          : {}),
        ...(comp.step !== undefined && comp.step !== ""
          ? { step: comp.step }
          : {}),
        pinned: false,
        pinned_snapshot: null,
      };
    });
  };

  const handleDetachFromLibrary = (intentName, fieldName) => {
    mutateFieldInIntent(intentName, fieldName, (f) => {
      const { component_id, pinned, pinned_snapshot, widget_type, ...rest } = f;
      return rest;
    });
  };

  const requestPinToggle = (intentName, fieldName) => {
    const field = (customFieldsMap[intentName] || []).find(
      (f) => f.field_name === fieldName,
    );
    if (!field?.component_id) return;
    const comp = library.find((c) => c.component_id === field.component_id);
    setPinModalTarget({
      intentName,
      fieldName,
      fieldLabel: field.label || field.field_name,
      componentName: comp?.name || null,
    });
    setPinModalMode(field.pinned ? "unpin" : "pin");
  };

  const applyPinDecision = (confirmed) => {
    if (!confirmed || !pinModalTarget) {
      setPinModalTarget(null);
      return;
    }
    const { intentName, fieldName } = pinModalTarget;
    const shouldPin = pinModalMode === "pin";

    mutateFieldInIntent(intentName, fieldName, (f) => {
      if (shouldPin) {
        const resolved = resolveFieldComponent(f, library);
        return {
          ...f,
          pinned: true,
          pinned_snapshot: {
            fieldType: resolved.fieldType,
            options: Array.isArray(resolved.options)
              ? resolved.options.map((o) =>
                  typeof o === "object"
                    ? { value: o.value, label: o.label }
                    : { value: String(o), label: String(o) },
                )
              : [],
            min: resolved.min ?? "",
            max: resolved.max ?? "",
            step: resolved.step ?? "",
          },
        };
      }
      return { ...f, pinned: false, pinned_snapshot: null };
    });
    setPinModalTarget(null);
  };

  const doSaveMapping = async (intent) => {
    const token = localStorage.getItem("token");
    let tenantId = null;
    try {
      if (token)
        tenantId = JSON.parse(atob(token.split(".")[1])).tenant_id;
    } catch (err) {
      log("Error extracting tenant_id", err);
    }

    const region = appData?.region?.toLowerCase() || "unknown";
    const appName = appData?.app_name;
    const apiConfigId = selectedApiConfigPerIntent[intent.name];
    const chainId = selectedChainPerIntent[intent.name];
    const botIcon = intentIcons[intent.name] || "";

    if (!apiConfigId && !chainId) {
      openAlert({
        heading: "Pick an API or Chain first",
        paragraph: `Select an API or Chain for "${intent.display_name}" before activating.`,
        icon: <FaInfoCircle size={28} />,
        iconColor: "#d97706",
        iconBG: "#fef3c7",
      });
      return;
    }

    const isChainRouted = !!chainId;
    const use_mode = isChainRouted ? "chain_api" : "single_api";

    const requiredFields = (customFieldsMap[intent.name] || []).map((f) => {
      const out = {
        type: f.type,
        field: f.field_name,
        label: f.label,
        required: f.required,
        placeholder: f.placeholder,
      };
      if (f.format) out.format = f.format;
      if (f.component_id) {
        out.component_id = f.component_id;
        out.widget_type = f.widget_type || f.type;
        if (f.pinned && f.pinned_snapshot) {
          out.pinned = true;
          out.pinned_snapshot = f.pinned_snapshot;
        }
      }
      return out;
    });

    const selectedApiConfig = apiConfigs.find(
      (cfg) => cfg.api_config_id === apiConfigId,
    );
    const isGetMethod =
      selectedApiConfig?.api_config?.method?.toUpperCase() === "GET";

    if (!requiredFields.length && !isGetMethod && !isChainRouted) {
      openAlert({
        heading: "Add a field first",
        paragraph: `Add at least one field for "${intent.display_name}" below.`,
        icon: <FaInfoCircle size={28} />,
        iconColor: "#d97706",
        iconBG: "#fef3c7",
      });
      return;
    }

    const existingIntentRecord = intentRecords.find(
      (r) => r.intent_type === intent.name,
    );
    const existingFormUuid = existingIntentRecord?.form_uuid;
    const hasReusableFormUuid =
      typeof existingFormUuid === "string" &&
      existingFormUuid.trim() !== "" &&
      existingFormUuid !== "__NA__";
    const formUuidToSend = hasReusableFormUuid
      ? existingFormUuid
      : `form_na_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

    let description = "";
    let examples = [];
    let rules = [];

    if (existingIntentRecord) {
      description = existingIntentRecord.description || "";
      examples = existingIntentRecord.examples || [];
      rules = existingIntentRecord.rules || [];
    } else if (intent.is_app_level) {
      const appIntent = appLevelIntents.find(
        (ai) => ai.intent_key === intent.name,
      );
      if (appIntent) {
        description = appIntent.description || "";
        examples = appIntent.examples || [];
        rules = appIntent.rules || [];
      }
    } else {
      const industryDesc = intentDescriptions;
      const subDesc = industryDesc?.[subIndustry];
      const allDescriptions = {
        ...(industryDesc?.default || {}),
        ...(subDesc?.extras || {}),
      };
      const descriptionData = allDescriptions[intent.name] || {};
      description = descriptionData?.description || "";
      examples = descriptionData?.examples || [];
      rules = descriptionData?.rules || [];
    }

    const meData = JSON.parse(localStorage.getItem("meData"));
    const showOnContainer =
      showOnCustomIntentContainerMap[intent.name] !== false;

    const intentApiPayload = {
      tenant_id: meData.tenant_info.id,
      kb_id: kbId,
      region,
      intent_type: intent.name,
      description,
      examples: examples || [],
      rules: rules || [],
      is_active: true,
      show_on_custom_intent_container: showOnContainer,
      required_fields: requiredFields,
      form_uuid: formUuidToSend,
      use_mode,
      bot_icon: botIcon,
    };

    try {
      const createUrl = getAutobotUrl(`/ai_ingest_sys`, {
        task: "custom-intents/create",
      });
      const intentResp = await fetch(createUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token || "",
        },
        body: JSON.stringify(intentApiPayload),
      });
      if (!intentResp.ok)
        throw new Error(`Intent API failed: ${intentResp.status}`);

      const apiConfigPayload = {
        tenant_id: tenantId,
        app_name: appName,
        form_uuid: formUuidToSend,
        ...(isChainRouted
          ? { chain_id: chainId }
          : { api_config_id: apiConfigId }),
      };
      const apiBaseUrl = `https://${region}.autobot2.${backend_api_base_url}`;
      const cfgResp = await fetch(`${apiBaseUrl}/form_api_config`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(apiConfigPayload),
      });

      if (!cfgResp.ok) {
        // ⭐ P2: inline 403 banner on save. Backend returns
        // `assert_attached` with a specific error message when the
        // tenant config or chain isn't attached to this app. Surface
        // it as a dismissible banner at the top of the card list
        // instead of an alert so the operator can see which intent
        // tripped it while they open the corresponding tab in
        // APIConfigIndex / ChainApis and attach it.
        let body = {};
        try {
          body = await cfgResp.json();
        } catch (_) {}
        const msg =
          body?.error ||
          body?.detail ||
          `Form mapping failed (HTTP ${cfgResp.status})`;

        const isAttachmentRefusal =
          cfgResp.status === 403 ||
          (typeof msg === "string" &&
            msg.includes("has not opted in to tenant-scoped"));

        if (isAttachmentRefusal) {
          setAttachmentRefusal({
            intentName: intent.name,
            intentDisplayName: intent.display_name,
            resourceType: isChainRouted ? "chain" : "api_config",
            resourceId: isChainRouted ? chainId : apiConfigId,
            message: msg,
          });
          // Do not proceed to the intent create — the mapping is the
          // first step, and it failed. Leaving the intent record
          // unpersisted means the operator can retry the whole flow
          // once they've attached the resource.
          return;
        }

        throw new Error(msg);
      }

      setIntentRecords((prev) => [
        ...prev.filter((r) => r.intent_type !== intent.name),
        { ...intentApiPayload, form_uuid: formUuidToSend },
      ]);
      setFormConfigs((prev) => [
        ...prev.filter((c) => c.form_uuid !== formUuidToSend),
        {
          form_uuid: formUuidToSend,
          api_config_id: isChainRouted ? "" : apiConfigId,
          chain_id: isChainRouted ? chainId : "",
        },
      ]);

      setEditingIntents((prev) => prev.filter((name) => name !== intent.name));
      setEditSnapshots((prev) => {
        const n = { ...prev };
        delete n[intent.name];
        return n;
      });

      if (!existingIntentRecord && intent.is_app_level) {
        try {
          const delDraftUrl = getAutobotUrl(`/ai_ingest_sys`, {
            task: `app-intents/${encodeURIComponent(meData.tenant_info.id)}/${encodeURIComponent(kbId)}/${encodeURIComponent(intent.name)}`,
            region,
            hard: "true",
          });
          const delResp = await fetch(delDraftUrl, {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              Authorization: token || "",
            },
          });
          if (delResp.ok) {
            setAppLevelIntents((prev) =>
              prev.filter((ai) => ai.intent_key !== intent.name),
            );
          } else {
            log("Draft hard-delete failed (non-fatal)", {
              intent: intent.name,
              status: delResp.status,
            });
          }
        } catch (draftErr) {
          log("Draft hard-delete exception (non-fatal)", {
            intent: intent.name,
            error: String(draftErr),
          });
        }
      }

      openAlert({
        heading: "Ready to use",
        paragraph: `"${intent.display_name}" is now active and ready to respond to visitors.`,
        icon: <FaCheckCircle size={28} />,
        iconColor: "#16a34a",
        iconBG: "#dcfce7",
      });

      fetchRecentBatches();
    } catch (error) {
      openAlert({
        heading: "Couldn't activate this skill",
        paragraph: `${intent.display_name}: ${error.message}`,
        icon: <FaTimesCircle size={28} />,
        iconColor: "#dc2626",
        iconBG: "#fee2e2",
      });
    }
  };

  const handleSaveMapping = (intent) => {
    if (
      !selectedApiConfigPerIntent[intent.name] &&
      !selectedChainPerIntent[intent.name]
    ) {
      openAlert({
        heading: "Pick an API or Chain first",
        paragraph: `Select an API or Chain for "${intent.display_name}" before activating.`,
        icon: <FaInfoCircle size={28} />,
        iconColor: "#d97706",
        iconBG: "#fef3c7",
      });
      return;
    }

    const draftRecord = intent.is_app_level
      ? appLevelIntents.find((ai) => ai.intent_key === intent.name)
      : null;

    const suggestedApi = draftRecord?.suggested_from_api_config_id || null;
    const suggestedChain = draftRecord?.suggested_from_chain_id || null;

    const pickedApi = selectedApiConfigPerIntent[intent.name] || "";
    const pickedChain = selectedChainPerIntent[intent.name] || "";

    const changedApi =
      suggestedApi && pickedApi && suggestedApi !== pickedApi;
    const changedChain =
      suggestedChain && pickedChain && suggestedChain !== pickedChain;

    if (changedApi || changedChain) {
      openConfirmPopup({
        heading: "Wire against a different endpoint?",
        paragraph: `The AI drafted "${intent.display_name}" against ${
          changedChain ? "a different Chain" : "a different API"
        }. You're about to wire it to ${
          pickedChain ? "a different Chain" : "a different API"
        } instead. This is allowed — confirm only if it's intentional.`,
        confirmText: "Wire anyway",
        cancelText: "Cancel",
        icon: <FaInfoCircle size={28} />,
        iconColor: "#d97706",
        iconBG: "#fef3c7",
        onConfirm: () => {
          closePopup();
          doSaveMapping(intent);
        },
      });
      return;
    }

    doSaveMapping(intent);
  };

  const savedIntents = useMemo(
    () => intentRecords.map((r) => r.intent_type),
    [intentRecords],
  );

  const configuredIntents = useMemo(() => {
    const set = new Set();
    const liveApiConfigIds = new Set(
      apiConfigs.map((c) => c.api_config_id),
    );
    const liveChainIds = new Set(chains.map((c) => c.chain_id));
    intentRecords.forEach((ir) => {
      if (!ir.form_uuid) return;
      const mapping = formConfigs.find((c) => c.form_uuid === ir.form_uuid);
      if (!mapping) return;
      const hasLiveApi =
        mapping.api_config_id && liveApiConfigIds.has(mapping.api_config_id);
      const hasLiveChain =
        mapping.chain_id && liveChainIds.has(mapping.chain_id);
      const hasInlineApi =
        mapping.api_config &&
        typeof mapping.api_config === "object" &&
        Object.keys(mapping.api_config).length > 0;
      if (hasLiveApi || hasLiveChain || hasInlineApi) set.add(ir.intent_type);
    });
    return Array.from(set);
  }, [intentRecords, formConfigs, apiConfigs, chains, deleteTrigger]);

  const wiredKeys = useMemo(() => {
    return new Set([
      ...intentRecords.map((r) => r.intent_type),
      ...configuredIntents,
    ]);
  }, [intentRecords, configuredIntents]);

  const isLoading =
    loadingForms ||
    loadingConfigs ||
    descriptionsLoading ||
    loadingAppIntents;

  if (isLoading)
    return (
      <div style={{ padding: "40px", textAlign: "center" }}>
        <h3>Preparing your AI Agent skills...</h3>
        <p>Loading your skill definitions{loadingForms ? "..." : " ✓"}</p>
        <p>
          Loading connected APIs and Chains{loadingConfigs ? "..." : " ✓"}
        </p>
        <p>
          Loading skill descriptions{descriptionsLoading ? "..." : " ✓"}
        </p>
        <p>Loading custom skills{loadingAppIntents ? "..." : " ✓"}</p>
      </div>
    );
  if (error || descriptionsError)
    return (
      <div
        style={{ padding: "10px", background: "#ffebee", color: "#c62828" }}
      >
        Error: {error || descriptionsError}
      </div>
    );

  return (
    <div className={styles.aiAgentWrapper}>
      <div className={styles.headerSection}>
        <div
          style={{
            padding: "16px 20px",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
            border: "1px solid #e0e0e0",
            marginBottom: "24px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "16px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "24px",
                flexWrap: "wrap",
              }}
            >
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  cursor: "pointer",
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "#2d3748",
                }}
              >
                <input
                  type="checkbox"
                  checked={aiAgentBotEnabled}
                  onChange={(e) => setAiAgentBotEnabled(e.target.checked)}
                  style={{
                    width: "20px",
                    height: "20px",
                    accentColor: "#4a7feb",
                  }}
                />
                Enable AI Agent Bot
                <InfoTooltip text="This is effectively the master switch for the AI Agent Bot Screen. If disabled, the entire screen where the AI chat and custom intent shortcuts live will not be shown to the visitor." />
              </label>

              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <span style={{ fontSize: "14px", color: "#4a5568" }}>
                  Skill Layout:
                </span>
                <div
                  style={{
                    display: "flex",
                    backgroundColor: "#e2e8f0",
                    borderRadius: "6px",
                    padding: "2px",
                  }}
                >
                  <button
                    onClick={() => setCustomIntentUiLayout("stack")}
                    style={{
                      padding: "4px 12px",
                      border: "none",
                      borderRadius: "4px",
                      fontSize: "13px",
                      fontWeight: 500,
                      cursor: "pointer",
                      backgroundColor:
                        customIntentUiLayout === "stack"
                          ? "#fff"
                          : "transparent",
                      color:
                        customIntentUiLayout === "stack"
                          ? "#2d3748"
                          : "#718096",
                      boxShadow:
                        customIntentUiLayout === "stack"
                          ? "0 1px 3px rgba(0,0,0,0.1)"
                          : "none",
                    }}
                  >
                    Stack
                  </button>
                  <button
                    onClick={() => setCustomIntentUiLayout("grid")}
                    style={{
                      padding: "4px 12px",
                      border: "none",
                      borderRadius: "4px",
                      fontSize: "13px",
                      fontWeight: 500,
                      cursor: "pointer",
                      backgroundColor:
                        customIntentUiLayout === "grid"
                          ? "#fff"
                          : "transparent",
                      color:
                        customIntentUiLayout === "grid"
                          ? "#2d3748"
                          : "#718096",
                      boxShadow:
                        customIntentUiLayout === "grid"
                          ? "0 1px 3px rgba(0,0,0,0.1)"
                          : "none",
                    }}
                  >
                    Grid
                  </button>
                </div>
                <InfoTooltip text="Choose how the custom skill buttons are displayed to visitors in the AI chat interface. Stack shows them in a vertical list. Grid shows them in a 2-column layout." />
              </div>
            </div>

            {hasAiBotChanges && (
              <button
                onClick={handleUpdateAiBotToggle}
                disabled={aiAgentBotUpdating}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#4a7feb",
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px",
                  cursor: aiAgentBotUpdating ? "not-allowed" : "pointer",
                  fontWeight: 500,
                  opacity: aiAgentBotUpdating ? 0.7 : 1,
                }}
              >
                {aiAgentBotUpdating ? "Updating..." : "AI Bot Update"}
              </button>
            )}
          </div>

          {!aiAgentBotEnabled && (
            <div
              style={{
                padding: "12px 16px",
                backgroundColor: "#fffbeb",
                border: "1px solid #fde68a",
                borderRadius: "6px",
                color: "#92400e",
                fontSize: "14px",
                lineHeight: "1.5",
                display: "flex",
                gap: "10px",
              }}
            >
              <div style={{ marginTop: "2px" }}>⚠️</div>
              <div>
                <strong>AI Agent Bot is currently disabled.</strong> The
                screen where these operations and the AI chat itself live will
                not be shown to visitors until this is enabled. You can still
                configure skills below, but they won't be accessible.
              </div>
            </div>
          )}
        </div>

        <h2 className={styles.title}>AI Agent Skills & API Mapping</h2>
        <p className={styles.subtitle}>
          A skill is what a visitor is trying to do — check an order, book a
          room, update a record. The AI Agent recognizes the skill from the
          conversation, then calls the API or Chain you've connected here.
        </p>
        <p className={styles.subtitle}>
          You've already defined <em>what happens</em> in{" "}
          <strong>Agent &amp; Servers → API Config</strong>. This screen just
          says: when <em>this</em> skill comes up, use <em>that</em> API.
        </p>

        {/* ⭐ P2: inline 403 banner on save. Renders only when a save
            tripped the attachment guard. Dismissible; the operator
            clicks it away after navigating to APIConfigIndex or
            ChainApis to attach the referenced resource. */}
        {attachmentRefusal && (
          <div
            role="alert"
            style={{
              margin: "12px 0",
              padding: "12px 16px",
              backgroundColor: "#fff8e1",
              border: "1px solid #fde68a",
              borderLeft: "3px solid #d97706",
              borderRadius: 6,
              color: "#78350f",
              fontSize: 13,
              lineHeight: 1.55,
              display: "flex",
              alignItems: "flex-start",
              gap: 10,
            }}
          >
            <span style={{ fontSize: 18, flexShrink: 0 }}>⚠️</span>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 600, marginBottom: 4 }}>
                Can&apos;t wire &quot;{attachmentRefusal.intentDisplayName}
                &quot; — the {attachmentRefusal.resourceType === "chain"
                  ? "chain"
                  : "API config"}{" "}
                isn&apos;t attached to this app.
              </div>
              <div>{attachmentRefusal.message}</div>
              <div style={{ marginTop: 6, color: "#92400e" }}>
                Open{" "}
                <strong>
                  {attachmentRefusal.resourceType === "chain"
                    ? "ChainApis → Tenant Level"
                    : "API Config → Tenant Level"}
                </strong>{" "}
                and attach this{" "}
                {attachmentRefusal.resourceType === "chain"
                  ? "chain"
                  : "config"}{" "}
                to this app, then retry.
              </div>
            </div>
            <button
              type="button"
              onClick={() => setAttachmentRefusal(null)}
              style={{
                background: "none",
                border: "none",
                color: "#78350f",
                cursor: "pointer",
                fontSize: 16,
                lineHeight: 1,
                padding: 4,
              }}
              aria-label="Dismiss"
            >
              ×
            </button>
          </div>
        )}

        <button
          onClick={() => setIsNewSkillModalOpen(true)}
          className={styles.manageButton}
        >
          <FaPlus size={12} style={{ marginRight: 6 }} />
          Add custom skill
        </button>
      </div>

      <RecentBatchesPanel
        batches={recentBatches}
        loading={recentBatchesLoading}
        expanded={showBatchPanel}
        onToggle={() => setShowBatchPanel((v) => !v)}
        onRefresh={fetchRecentBatches}
        wiredKeys={wiredKeys}
        onWireNow={wireIntentNow}
      />

      <div className={styles.cardWrap}>
        {allIntents.map((intent) => {
          const isIntentSaved = savedIntents.includes(intent.name);
          const isEditing = editingIntents.includes(intent.name);
          const apiConfigId = selectedApiConfigPerIntent[intent.name] || "";
          const chainId = selectedChainPerIntent[intent.name] || "";
          const selectedConfig = apiConfigs.find(
            (cfg) => cfg.api_config_id === apiConfigId,
          )?.api_config;
          const selectedChain = chains.find((c) => c.chain_id === chainId);
          const inferredFields = customFieldsMap[intent.name] || [];
          const fieldConfidence = fieldConfidenceMap[intent.name] || "none";
          const intentRecord = intentRecords.find(
            (r) => r.intent_type === intent.name,
          );
          const isActive = intentRecord?.is_active !== false;
          const isDraft = intentRecord?.draft === true;
          const isToggling = togglingIntent === intent.name;
          const isDeleting = deletingIntent === intent.name;
          const useMode = intentRecord?.use_mode || "single_api";
          const isActuallyConfigured = configuredIntents.includes(intent.name);
          const showOnCustomIntentContainer =
            showOnCustomIntentContainerMap[intent.name] !== false;
          const showLowConfidenceWarning =
            inferredFields.length > 0 &&
            (fieldConfidence === "low" || fieldConfidence === "mixed") &&
            !isActuallyConfigured;
          const siblingFormatWarning =
            isEditing || !isActuallyConfigured
              ? detectSiblingFormatMismatch(inferredFields)
              : null;
          const isHighlighted = highlightIntent === intent.name;

          return (
            <div
              key={intent.name}
              data-intent-key={intent.name}
              className={`${styles.cards} ${isIntentSaved ? styles.cardSaved : styles.cardUnsaved}`}
              style={
                isHighlighted
                  ? {
                      outline: "3px solid #4a7feb",
                      outlineOffset: 4,
                      transition: "outline 0.3s",
                    }
                  : undefined
              }
            >
              <div className={styles.cardHeader}>
                <div className={styles.cardTitleSection}>
                  <h3
                    className={
                      isIntentSaved ? styles.savedTitle : styles.unsavedTitle
                    }
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    {intentIcons[intent.name] && (
                      <i
                        className={intentIcons[intent.name]}
                        style={{ fontSize: "16px", color: "#4a7feb" }}
                      ></i>
                    )}
                    {intent.display_name}
                    {intent.is_custom && (
                      <span className={styles.appLevelBadge}>Custom</span>
                    )}
                    {intent.is_app_level && !intent.is_custom && (
                      <span className={styles.appLevelBadge}>Draft</span>
                    )}
                    {isDraft && (
                      <span
                        className={styles.appLevelBadge}
                        style={{
                          marginLeft: 6,
                          background: "#fef3c7",
                          color: "#92400e",
                          border: "1px solid #fcd34d",
                        }}
                      >
                        Draft
                      </span>
                    )}

                    {(!isActuallyConfigured || isEditing) &&
                      showOnCustomIntentContainer && (
                        <button
                          onClick={() => {
                            setIconPickerTarget(intent.name);
                            setShowIconPicker(true);
                          }}
                          style={{
                            background: "none",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            cursor: "pointer",
                            padding: "4px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginLeft: "4px",
                          }}
                          title="Select Icon for AI Chat"
                        >
                          {intentIcons[intent.name] ? (
                            <i
                              className={intentIcons[intent.name]}
                              style={{ fontSize: "14px", color: "#4a7feb" }}
                            ></i>
                          ) : (
                            <FaSearch size={12} color="#666" />
                          )}
                        </button>
                      )}
                  </h3>
                  <div className={styles.badgeContainer}>
                    {isActuallyConfigured ? (
                      <>
                        <span
                          className={
                            isActive
                              ? styles.badgeConfigured
                              : styles.badgeDisabled
                          }
                        >
                          {isActive ? "On" : "Off"}
                        </span>
                        <span className={styles.modeBadge}>
                          {useMode === "chain_api" ? "🔗 Chain" : "⚡ API"}
                        </span>
                        <button
                          onClick={() =>
                            handleToggleActive(intent.name, isActive)
                          }
                          className={
                            isActive
                              ? styles.toggleActiveBtn
                              : styles.toggleDisabledBtn
                          }
                          disabled={isToggling || isDeleting}
                          title={
                            isActive
                              ? "Turn this skill off"
                              : "Turn this skill on"
                          }
                        >
                          {isToggling
                            ? "Toggling..."
                            : isActive
                              ? "Turn off"
                              : "Turn on"}
                        </button>

                        <label
                          className={styles.checkboxLabel}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            marginLeft: "8px",
                            fontSize: "12px",
                            cursor:
                              isActuallyConfigured && !isEditing
                                ? "not-allowed"
                                : "pointer",
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={!showOnCustomIntentContainer}
                            onChange={(e) =>
                              setShowOnCustomIntentContainerMap((prev) => ({
                                ...prev,
                                [intent.name]: !e.target.checked,
                              }))
                            }
                            disabled={isActuallyConfigured && !isEditing}
                          />
                          <span>Hide from AI Bot</span>
                          <InfoTooltip text="When checked, this skill is hidden from the AI chat interface. It will not be detected during AI chat directly or shown in the custom intent shortcut links list. This is typically used for skills configured as triggers in the Control Plane." />
                        </label>
                      </>
                    ) : (
                      <span className={styles.badgeNotConfigured}>
                        Setup Required
                      </span>
                    )}
                  </div>
                </div>
                <div className={styles.actionButtons}>
                  {isActuallyConfigured && !isEditing && (
                    <>
                      <button
                        onClick={() => startEdit(intent.name)}
                        className={styles.editButton}
                      >
                        Modify
                      </button>
                      <button
                        onClick={() => handleDeleteIntent(intent.name)}
                        className={styles.deleteButton}
                        disabled={isDeleting || isToggling}
                        title="Remove this skill's API connection"
                      >
                        {isDeleting ? "Removing..." : "Remove connection"}
                      </button>
                    </>
                  )}
                  {isEditing && (
                    <button
                      onClick={() => cancelEdit(intent.name)}
                      className={styles.cancelButton}
                    >
                      Cancel
                    </button>
                  )}
                </div>
              </div>

              <div className={styles.formGroup}>
                                <label className={styles.formLabel}>
                  <strong>Handle this skill with an API:</strong>
                  <InfoTooltip text="Pick the API the AI Agent should call when a visitor asks for this skill. The API's URL, method, and expected inputs are all defined in Agent & Servers → API Config." />
                </label>
                <div className={styles.selectWrapper}>
                  <select
                    value={apiConfigId}
                    onChange={(e) => {
                      setSelectedApiConfigPerIntent((prev) => ({
                        ...prev,
                        [intent.name]: e.target.value,
                      }));
                      if (e.target.value)
                        setSelectedChainPerIntent((prev) => ({
                          ...prev,
                          [intent.name]: "",
                        }));
                    }}
                    className={`${styles.selectInput} ${styles.customSelect}`}
                    disabled={isActuallyConfigured && !isEditing}
                  >
                    <option value="">-- Select an API --</option>
                    {apiConfigs.filter(
                      (c) => c.scope === "app" || !c.scope,
                    ).length > 0 && (
                      <optgroup label="App Level (this app)">
                        {apiConfigs
                          .filter((c) => c.scope === "app" || !c.scope)
                          .map((cfg) => {
                            const shortId =
                              cfg.api_config_id?.split("-").pop() || "";
                            return (
                              <option
                                key={cfg.api_config_id}
                                value={cfg.api_config_id}
                              >
                                {shortId} — {cfg.api_config?.url ||
                                  cfg.api_config_id}{" "}
                                ({cfg.api_config?.method})
                              </option>
                            );
                          })}
                      </optgroup>
                    )}
                    {apiConfigs.filter((c) => c.scope === "tenant").length >
                      0 && (
                      <optgroup label="Shared (tenant-wide)">
                        {apiConfigs
                          .filter((c) => c.scope === "tenant")
                          .map((cfg) => {
                            const shortId =
                              cfg.api_config_id?.split("-").pop() || "";
                            return (
                              <option
                                key={cfg.api_config_id}
                                value={cfg.api_config_id}
                              >
                                {shortId} — {cfg.api_config?.url ||
                                  cfg.api_config_id}{" "}
                                ({cfg.api_config?.method})
                              </option>
                            );
                          })}
                      </optgroup>
                    )}
                  </select>
                  <FaAngleDown className={styles.selectIcon} />
                </div>
                {selectedConfig && (
                  <div className={styles.selectedConfigInfo}>
                    <strong>Connected to:</strong> {selectedConfig.url} (
                    {selectedConfig.method})
                  </div>
                )}
              </div>

              <div className={styles.orDivider}>
                <span>OR</span>
              </div>

              <div className={styles.formGroup}>
                <label className={styles.formLabel}>
                  <strong>Or handle it with a Chain:</strong>
                  <InfoTooltip text="A Chain runs several of your APIs in sequence — for example, Check Availability → Book Room → Confirm. Use this when a single skill needs more than one API call to complete. The AI Agent sends the visitor's input to the first API in the Chain; the Chain takes it from there." />
                </label>
                <div className={styles.selectWrapper}>
                  <select
                    value={chainId}
                    onChange={(e) => {
                      setSelectedChainPerIntent((prev) => ({
                        ...prev,
                        [intent.name]: e.target.value,
                      }));
                      if (e.target.value)
                        setSelectedApiConfigPerIntent((prev) => ({
                          ...prev,
                          [intent.name]: "",
                        }));
                    }}
                    className={`${styles.selectInput} ${styles.customSelect}`}
                    disabled={isActuallyConfigured && !isEditing}
                  >
                    <option value="">-- Select a Chain --</option>
                    {chains.filter((c) => c.scope === "app" || !c.scope)
                      .length > 0 && (
                      <optgroup label="App Level (this app)">
                        {chains
                          .filter((c) => c.scope === "app" || !c.scope)
                          .map((chain) => {
                            const chainStatus =
                              chain.enabled !== false ? "Active" : "Disabled";
                            return (
                              <option
                                key={chain.chain_id}
                                value={chain.chain_id}
                              >
                                {chain.name || "Unnamed Chain"} (
                                {chain.steps?.length || 0} step(s)) –{" "}
                                {chainStatus}
                              </option>
                            );
                          })}
                      </optgroup>
                    )}
                    {chains.filter((c) => c.scope === "tenant").length > 0 && (
                      <optgroup label="Shared (tenant-wide)">
                        {chains
                          .filter((c) => c.scope === "tenant")
                          .map((chain) => {
                            const chainStatus =
                              chain.enabled !== false ? "Active" : "Disabled";
                            return (
                              <option
                                key={chain.chain_id}
                                value={chain.chain_id}
                              >
                                {chain.name || "Unnamed Chain"} (
                                {chain.steps?.length || 0} step(s)) –{" "}
                                {chainStatus}
                              </option>
                            );
                          })}
                      </optgroup>
                    )}
                  </select>
                  <FaAngleDown className={styles.selectIcon} />
                </div>
                {selectedChain && (
                  <div className={styles.selectedConfigInfo}>
                    <strong>Connected to:</strong>{" "}
                    {selectedChain.name || "Unnamed"} (
                    {selectedChain.steps?.length} steps,{" "}
                    {selectedChain.enabled !== false ? "Active" : "Disabled"})
                  </div>
                )}
              </div>

              <div className={styles.formFieldsSection}>
                <div className={styles.sectionTitle}>
                  {chainId ? (
                    <>
                      Fields the user will provide (from the Chain's first
                      API): <strong>{selectedChain?.name || "Chain"}</strong>
                    </>
                  ) : apiConfigId ? (
                    <>
                      Fields the user will provide:{" "}
                      <strong>{selectedConfig?.url || "Config"}</strong>
                    </>
                  ) : (
                    <>
                      Pick an API or Chain above to see which fields the user
                      will be asked to provide.
                    </>
                  )}
                  <InfoTooltip text="These are the details the AI Agent will ask the visitor for during the conversation — then pass along to your API. For example, a Book Room skill might ask for check-in date, check-out date, and room type. Fields are inferred from your API's expected inputs. You can edit their type or format below if needed. You can also attach a UI Field Component to any field to keep its shape in sync with the Library." />
                </div>

                {showLowConfidenceWarning && (
                  <div
                    style={{
                      margin: "8px 0",
                      padding: "10px 12px",
                      background: "#fff8e1",
                      border: "1px solid #ffd54f",
                      borderRadius: "6px",
                      fontSize: "12px",
                      color: "#5d4037",
                      lineHeight: 1.5,
                    }}
                  >
                    <strong>⚠️ Field types and formats are guesses.</strong>{" "}
                    Your API Config didn't include real sample values for these
                    fields, so we've guessed their types and formats. Please
                    review each one below and correct anything that looks wrong
                    — a wrong date format or number type can cause your API to
                    reject the request.
                    <br />
                    <br />
                    Not sure? Open <strong>Agent &amp; Servers → API Config</strong>{" "}
                    and check the sample payload you saved.
                  </div>
                )}

                {siblingFormatWarning && (
                  <div
                    style={{
                      margin: "8px 0",
                      padding: "10px 12px",
                      background: "#fff8e1",
                      border: "1px solid #ffd54f",
                      borderRadius: "6px",
                      fontSize: "12px",
                      color: "#5d4037",
                      lineHeight: 1.5,
                    }}
                  >
                    <strong>
                      ⚠️ Fields with the same type use different formats.
                    </strong>{" "}
                    {siblingFormatWarning}
                  </div>
                )}

                <InferredFieldsBuilder
                  fields={inferredFields}
                  onFieldsChange={(newFields) =>
                    handleCustomFieldsChange(intent.name, newFields)
                  }
                  isConfigured={isActuallyConfigured && !isEditing}
                  readOnly={false}
                  library={library}
                  libraryLoading={libraryLoading}
                  intentName={intent.name}
                  onOpenPicker={(fieldName) => {
                    setPickerTargetPath({
                      intentName: intent.name,
                      fieldName,
                    });
                    setShowPicker(true);
                  }}
                  onReimportFromLibrary={(fieldName) =>
                    handleReimportFromLibrary(intent.name, fieldName)
                  }
                  onDetachFromLibrary={(fieldName) =>
                    handleDetachFromLibrary(intent.name, fieldName)
                  }
                  onRequestPinToggle={(fieldName) =>
                    requestPinToggle(intent.name, fieldName)
                  }
                  formUuid={intentRecord?.form_uuid || null}
                  appName={appData?.app_name}
                  region={appData?.region}
                />
              </div>

              {(!isActuallyConfigured || isEditing) && (
                <div className={styles.saveButtonContainer}>
                  <button
                    onClick={() => handleSaveMapping(intent)}
                    className={styles.saveButton}
                    disabled={!apiConfigId && !chainId}
                  >
                    {isEditing
                      ? `Update "${intent.display_name}"`
                      : `Activate "${intent.display_name}"`}
                  </button>
                  {!apiConfigId && !chainId && (
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#ed8936",
                        marginTop: "4px",
                      }}
                    >
                      Pick an API or Chain above to continue.
                    </div>
                  )}
                </div>
              )}

              {isActuallyConfigured && !isEditing && (
                <div className={styles.activeConfigInfo}>
                  <strong>✓ {isActive ? "On" : "Off"}</strong>
                  <div>
                    Handled by:{" "}
                    {useMode === "chain_api" ? "🔗 Chain" : "⚡ API"}
                  </div>
                  {selectedConfig && (
                    <div>API: {selectedConfig?.url || "None"}</div>
                  )}
                  {selectedChain && (
                    <div>Chain: {selectedChain?.name || "None"}</div>
                  )}
                  <div>
                    AI Chat detection:{" "}
                    {showOnCustomIntentContainer ? "Enabled" : "Disabled"}
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div className={styles.summarySection}>
        <h3 className={styles.summaryTitle}>Skill Overview</h3>
        <div className={styles.summaryGrid}>
          <div className={styles.summaryItem}>
            <span className={styles.summaryLabel}>Tenant ID:</span>
            <span className={styles.summaryValue}>
              {(() => {
                try {
                  const token = localStorage.getItem("token");
                  if (token) {
                    const payload = JSON.parse(atob(token.split(".")[1]));
                    return payload.tenant_id || "N/A";
                  }
                  return "N/A";
                } catch {
                  return "N/A";
                }
              })()}
            </span>
          </div>
          <div className={styles.summaryItem}>
            <span className={styles.summaryLabel}>KB ID:</span>
            <span className={styles.summaryValue}>{kbId || "N/A"}</span>
          </div>
          <div className={styles.summaryItem}>
            <span className={styles.summaryLabel}>Region:</span>
            <span className={styles.summaryValue}>
              {appData?.region?.toLowerCase() || "N/A"}
            </span>
          </div>
          <div className={styles.summaryItem}>
            <span className={styles.summaryLabel}>Available skills:</span>
            <span className={styles.summaryValue}>{allIntents.length}</span>
          </div>
          <div className={styles.summaryItem}>
            <span className={styles.summaryLabel}>Built-in (by industry):</span>
            <span className={styles.summaryValue}>{globalIntents.length}</span>
          </div>
          <div className={styles.summaryItem}>
            <span className={styles.summaryLabel}>Custom (added by you):</span>
            <span className={styles.summaryValue}>
              {intentRecords.length}
            </span>
          </div>
          <div className={styles.summaryItem}>
            <span className={styles.summaryLabel}>
              Connected to an API or Chain:
            </span>
            <span className={styles.summaryValue}>{savedIntents.length}</span>
          </div>
          <div className={styles.summaryItem}>
            <span className={styles.summaryLabel}>
              Ready to respond to visitors:
            </span>
            <span className={styles.summaryValue}>
              {configuredIntents.length}
            </span>
          </div>
        </div>
      </div>

      <NewCustomSkillModal
        isOpen={isNewSkillModalOpen}
        onClose={() => setIsNewSkillModalOpen(false)}
        appData={appData}
        kbId={kbId}
        apiConfigs={apiConfigs}
        chains={chains}
        intentRecords={intentRecords}
        getAutobotUrl={getAutobotUrl}
        onSaved={handleNewSkillSaved}
        onDraftsCreated={handleDraftsCreated}
        onWireNow={wireIntentNow}
      />
      <ComponentPickerModal
        isOpen={showPicker}
        onClose={() => {
          setShowPicker(false);
          setPickerTargetPath(null);
        }}
        library={library}
        loading={libraryLoading}
        onSelect={handlePickerSelect}
      />
      <PinConfirmModal
        isOpen={!!pinModalTarget}
        onClose={() => setPinModalTarget(null)}
        onConfirm={() => applyPinDecision(true)}
        mode={pinModalMode}
        fieldLabel={pinModalTarget?.fieldLabel || ""}
        componentName={pinModalTarget?.componentName || ""}
      />

      {showIconPicker && (
        <FontAwesomeIconPicker
          onSelect={(icon) => {
            if (iconPickerTarget) {
              setIntentIcons((prev) => ({
                ...prev,
                [iconPickerTarget]: icon,
              }));
            }
          }}
          onClose={() => setShowIconPicker(false)}
        />
      )}

      <ReusablePopup
        isOpen={popup.isOpen}
        onClose={closePopup}
        onConfirm={popup.onConfirm}
        icon={popup.icon}
        iconColor={popup.iconColor}
        iconBG={popup.iconBG}
        heading={popup.heading}
        subtext={popup.subtext}
        paragraph={popup.paragraph}
        cancelText={popup.cancelText}
        confirmText={popup.confirmText}
        showCancel={!!popup.cancelText}
        showConfirm={true}
      />
    </div>
  );
}